import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "min-h-[100vh] bg-gray-950 flex flex-col md:flex-row md:justify-center"
};
const _hoisted_2 = {
  class: "flex-1 md:max-w-[35rem] pt-6"
};
const _hoisted_3 = {
  class: "text-white font-mono text-4xl font-bold ml-4 mt-4 mr-4 flex flex-col"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-11/12 h-[0.1rem] bg-white mt-3 mb-2"
}, null, -1);
const _hoisted_5 = {
  class: "font-normal text-xl mb-4"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl"
}, "Create Invite Link ", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-base font-normal text-gray-400 mb-2"
}, [/*#__PURE__*/_createTextVNode("When anyone who use your link to create Solana Token in Minthe, you will get "), /*#__PURE__*/_createElementVNode("span", {
  class: "font-bold text-pink-600"
}, "20%"), /*#__PURE__*/_createTextVNode(" as rewards!")], -1);
const _hoisted_8 = {
  key: 0,
  class: "mt-4 mb-4 text-2xl text-pink-800"
};
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col space-x-2 items-center mt-2 mb-2 lg:flex-row"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 i-mdi-check"
}, null, -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-lg"
}, "OR", -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 i-mdi-creation"
}, null, -1);
const _hoisted_13 = {
  key: 2,
  class: "text-pink-600 text-xl"
};
const _hoisted_14 = {
  class: "text-2xl"
};
const _hoisted_15 = {
  class: "text-base font-normal text-gray-400"
};
const _hoisted_16 = {
  key: 3,
  class: "mt-4 mb-4 text-2xl text-pink-800"
};
const _hoisted_17 = {
  key: 4,
  class: "text-pink-600 text-xl"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl text-gray-400 mt-5 mb-3"
}, "Your account have ", -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_20 = {
  class: "flex items-center justify-between"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-end"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl text-gray-400 mt-2"
}, "Can be claimed!")], -1);
const _hoisted_23 = {
  key: 6,
  class: "text-pink-600 text-xl"
};
const _hoisted_24 = {
  class: "text-red-600 text-xl mt-6"
};
const _hoisted_25 = ["disabled"];
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-1 md:max-w-[30rem] text-white font-mono flex flex-col text-xl p-6 space-y-3"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-3xl font-bold mt-4"
}, "Create Solana Token"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("Effortlessly create your Solana SPL Token with our 7+1 step process – "), /*#__PURE__*/_createElementVNode("span", {
  class: "font-bold"
}, "no coding required"), /*#__PURE__*/_createTextVNode(".")]), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("Customize your Solana Token exactly the way you envision it. Less than "), /*#__PURE__*/_createElementVNode("span", {
  class: "underline"
}, "5 minutes"), /*#__PURE__*/_createTextVNode(", at an affordable cost.")]), /*#__PURE__*/_createElementVNode("br")], -1);
import { getInvitionDataByPubkey, putInvitionData } from '@/invite';
import { useStore } from '@/store';
import { ref } from 'vue';
import { createInviteLink, claimBalance } from '@/wallets';
import { Connection } from '@solana/web3.js';
import { getClaimableBalance } from '@/wallets';
export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimPage',
  setup(__props) {
    const store = useStore();
    const error_msg = ref("");
    const balance = ref(0.0);
    const invite_code = ref("");
    const error_msg_create_link = ref("");
    const error_msg_claim = ref("");
    const fetch_balance_running = ref(false);
    const claim_running = ref(false);
    async function clickClaim() {
      claim_running.value = true;
      error_msg_claim.value = "";
      const wallet = useStore().activate_wallet;
      if (!wallet) {
        return;
      }
      const connection = new Connection(`https://api.${wallet.network}.solana.com`);
      try {
        await claimBalance(connection, wallet);
      } catch (e) {
        error_msg_claim.value = `Error: ${e}`;
      }
      claim_running.value = false;
    }
    async function clickCreateLink() {
      error_msg_create_link.value = "";
      const wallet = useStore().activate_wallet;
      if (!wallet) {
        return;
      }
      const connection = new Connection(`https://api.${wallet.network}.solana.com`);
      const pubkey = wallet.adapter.publicKey;
      if (!pubkey) {
        return;
      }
      try {
        await createInviteLink(connection, wallet);
        invite_code.value = await putInvitionData({
          pubkey: pubkey === null || pubkey === void 0 ? void 0 : pubkey.toBase58(),
          id_byte: 10
        });
      } catch (error) {
        error_msg_create_link.value = `Error: ${error}`;
      }
    }
    async function clickFetchCreatedLink() {
      error_msg_create_link.value = "";
      try {
        var _store$activate_walle;
        if ((_store$activate_walle = store.activate_wallet) !== null && _store$activate_walle !== void 0 && _store$activate_walle.adapter.publicKey) {
          invite_code.value = (await getInvitionDataByPubkey(store.activate_wallet.adapter.publicKey.toString())).last_code;
        }
      } catch (error) {
        error_msg_create_link.value = `Error: ${error}`;
      }
    }
    async function clickFetchBanlance() {
      fetch_balance_running.value = true;
      const wallet = store.activate_wallet;
      error_msg.value = "";
      if (!wallet) {
        return;
      }
      try {
        const result = await getClaimableBalance(wallet);
        balance.value = result[0];
      } catch (e) {
        error_msg.value = `Error: ${e}`;
      }
      fetch_balance_running.value = false;
    }
    return (_ctx, _cache) => {
      const _component_LinkShow = _resolveComponent("LinkShow");
      const _component_LoadingIcon = _resolveComponent("LoadingIcon");
      const _component_SolanaLogo = _resolveComponent("SolanaLogo");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('titles.claimCollector')), 1), _hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('descriptions.claimCollector')), 1), _hoisted_6, _hoisted_7, !_unref(store).activate_wallet ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_createTextVNode("To continue, Please "), _createElementVNode("span", {
        class: "text-pink-600 underline cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => _unref(store).show_wallet_model = true)
      }, "Connect"), _createTextVNode(" a wallet.")])) : _createCommentVNode("", true), _unref(store).activate_wallet ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("button", {
        onClick: clickFetchCreatedLink,
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2"
      }, [_hoisted_10, _createTextVNode(" Check Link Your Have Created ")]), _hoisted_11, _createElementVNode("button", {
        onClick: clickCreateLink,
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2"
      }, [_hoisted_12, _createTextVNode(" Create A New Link ")])])) : _createCommentVNode("", true), error_msg_create_link.value != '' ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(error_msg_create_link.value), 1)) : _createCommentVNode("", true), _createVNode(_component_LinkShow, {
        show: _unref(store).activate_wallet != undefined,
        invite_code: invite_code.value
      }, null, 8, ["show", "invite_code"]), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('labels.claimAccountInfo')), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('hints.claimAccountInfo')), 1), !_unref(store).activate_wallet ? (_openBlock(), _createElementBlock("span", _hoisted_16, [_createTextVNode("To continue, Please "), _createElementVNode("span", {
        class: "text-pink-600 underline cursor-pointer",
        onClick: _cache[1] || (_cache[1] = $event => _unref(store).show_wallet_model = true)
      }, "Connect"), _createTextVNode(" a wallet.")])) : _createCommentVNode("", true), error_msg.value != '' ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(error_msg.value), 1)) : _createCommentVNode("", true), _unref(store).activate_wallet ? (_openBlock(), _createElementBlock("button", {
        key: 5,
        onClick: clickFetchBanlance,
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2 mt-2 justify-center"
      }, [_createVNode(_component_LoadingIcon, {
        loading: fetch_balance_running.value
      }, {
        default: _withCtx(() => {
          var _unref$activate_walle, _unref$activate_walle2;
          return [_createTextVNode(" Fetch Balance With Wallet " + _toDisplayString(`${_unref(store).activate_wallet.name}:
                        ${(_unref$activate_walle = _unref(store).activate_wallet.adapter.publicKey) === null || _unref$activate_walle === void 0 ? void 0 : _unref$activate_walle.toBase58().substring(0, 4)}....${(_unref$activate_walle2 = _unref(store).activate_wallet.adapter.publicKey) === null || _unref$activate_walle2 === void 0 ? void 0 : _unref$activate_walle2.toBase58().slice(-4)}`), 1)];
        }),
        _: 1
      }, 8, ["loading"])])) : _createCommentVNode("", true), _hoisted_18, _hoisted_19, _createElementVNode("span", _hoisted_20, [_createVNode(_component_SolanaLogo, {
        class: "h-[3rem]"
      }), _createTextVNode(" " + _toDisplayString((() => {
        let str = balance.value.toString();
        str = str.padStart(10, "0");
        str = str.substring(0, str.length - 9) + "." + str.substring(str.length - 9, str.length);
        return str;
      })()), 1)]), _hoisted_21, _hoisted_22, error_msg_claim.value != '' ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(error_msg_claim.value), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_24, _toDisplayString(error_msg.value), 1), _createElementVNode("button", {
        disabled: claim_running.value,
        onClick: clickClaim,
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-4 rounded items-center mt-3 w-full transition-colors"
      }, [_createVNode(_component_LoadingIcon, {
        loading: claim_running.value
      }, {
        default: _withCtx(() => [_createTextVNode(" Claim! ")]),
        _: 1
      }, 8, ["loading"])], 8, _hoisted_25)])]), _hoisted_26]);
    };
  }
});